import { KyronClient } from './utils/KyronClient';
import { getCurrentUser } from '../controllers/users';

export const enum StudentEnrollmentStatus {
  Enrolled = 'enrolled',
  NotEnrolled = 'not enrolled',
  Unauthorized = 'unauthorized',
}

export type ClassroomCredentials = {
  classroomId: string;
  status: StudentEnrollmentStatus;
  error?: string;
};

enum Provider {
  KyronLearning = 'kyron_learning',
}

export async function classroomLoader(): Promise<ClassroomCredentials | undefined> {
  const urlParams = new URLSearchParams(window.location.search);
  const classroomId = urlParams.get('classroom_id');
  const googleClassroomId = urlParams.get('google_classroom_id');
  const provider = urlParams.get('provider');
  const path = encodeURIComponent(window.location.pathname + window.location.search);

  if (!classroomId) {
    return;
  }
  if (provider === Provider.KyronLearning) {
    const user = await getCurrentUser();
    if (!user) {
      window.location.href = `/login?redirect_to=${path}`;
      return { classroomId, status: StudentEnrollmentStatus.Unauthorized };
    }
    return { classroomId, status: StudentEnrollmentStatus.Enrolled };
  }

  const client = new KyronClient();
  try {
    const response = await client.getDataWithError<ClassroomCredentials>(
      `/api/v1/students/check_credentials?classroom_id=${classroomId}&google_classroom_id=${googleClassroomId}`,
    );
    const { status } = response;

    return { classroomId, status };
  } catch (e) {
    console.error(e);
    return { classroomId, status: StudentEnrollmentStatus.Unauthorized };
  }
}
